import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { faPlain } from 'utilities/helper/format'
import useSetShareUser from './hooks/useSetShareUser'
import { parseShareInput, SHARE_INPUT_ERROR } from './parseShareInput'
interface IModalProps {
    show: boolean
    onHide: () => void
    user: IMoneyPoolResults | undefined
    refetch?: () => void
}
export default function ChangeShareModal({
    show,
    onHide,
    user,
    refetch,
}: IModalProps) {
    const { id } = useParams()
    const [value, setValue] = useState<string>('')
    const [error, setError] = useState<string>('')
    const { mutate } = useSetShareUser(refetch)
    const close = () => {
        setValue('')
        setError('')
        onHide()
    }
    return (
        <Modal
            show={show}
            onHide={close}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-sm px-4">
                <p className=" mb-3">
                    تعداد سهم های {user?.member.first_name}{' '}
                    {user?.member.last_name} را تعیین کنید
                </p>
                <input
                    type="text"
                    inputMode="numeric"
                    aria-label="تعداد سهم"
                    className=" outline-none border-1 border-gray-5 rounded-md w-full py-2.5 text-center"
                    onChange={(e) => {
                        setValue(e.target.value)
                        setError('')
                    }}
                    value={value}
                    placeholder={
                        user?.number_of_shares != null
                            ? `الان ${faPlain.format(user.number_of_shares)} سهم`
                            : undefined
                    }
                    min={0}
                />
                {!!error && (
                    <p role="alert" className=" mt-2 text-xs text-danger-on">
                        {error}
                    </p>
                )}
                <hr className=" my-3" />
                <p
                    className=" text-center text-green-1"
                    onClick={() => {
                        if (!user) return
                        const parsed = parseShareInput(
                            value,
                            user.number_of_shares
                        )
                        if (!parsed.ok) {
                            // The same count again is not a change: close
                            // without a request, so no Share row and no line
                            // in تاریخچهٔ تعداد سهم (pwa#135).
                            if (parsed.reason === 'unchanged') close()
                            else setError(SHARE_INPUT_ERROR[parsed.reason])
                            return
                        }
                        const payload: IChangeShareSettingPayload = {
                            moneyPool: id,
                            poolShip: user?.id,
                            share: parsed.value,
                            role: user.role,
                            guarantor: user.guarantor?.id ?? null,
                            recommender: user.recommender?.id ?? null,
                        }
                        mutate(payload)
                        close()
                    }}
                >
                    تایید
                </p>
            </div>
        </Modal>
    )
}
